import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { MyContext } from "../hooks/MyContextProvider";
import Header from "../Layout/Header";
import useBreakPoints from "../hooks/useBreakPoints";
import Sidebar from "../Layout/Sidebar";
import Loader from "../Component/Loader";

const AuthProtected = () => {
  const { isTablet } = useBreakPoints();
  const { token, loading } = useContext(MyContext);
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  console.log(token, "token");
  if (loading) {
    return <Loader />;
  }
  // Render child routes here using Outlet
  return (
    <>
      <div className="page-wrapper null compact-wrapper" id="pageWrapper">
        <Header />
        <div className="page-body-wrapper">
          <Sidebar />
          <Outlet />
        </div>
      </div>
    </>
  );
};

const AccessRoute = ({ component: Component }) => {
  // Render the passed component as a JSX element
  return <>{Component}</>;
};

export { AuthProtected, AccessRoute };
